import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Meteo from '../views/Meteo.vue'
import Calcul from '../views/Calcul.vue'
import Todo from '../views/Todo.vue'
import Sort from '../views/Sort.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/meteo',
    name: 'Meteo',
    component: Meteo
  },
  {
    path: '/calcul',
    name: 'Calcul',
    component: Calcul
  },
  {
    path: '/todo',
    name: 'Todo',
    component: Todo
  },
  {
    path: '/sort',
    name: 'Sort',
    component: Sort
  },
  {
    path: '*',
    component: Home
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

export default router
